import type { FilterGroup } from '@risksmart-app/shared/reporting/api/schema';

/**
 * Builds a reporting FilterGroup that ORs the selected dashboard tag names onto
 * the root datasource's `tags` field.
 *
 * The reporting engine inlines the `tags` field as a jsonb array of tag *names*
 * (`tag_type.Name`), so the filter value must be the tag name — not the
 * TagTypeId held in the dashboard store. Callers resolve ids to names first.
 *
 * Uses the ':' (ILIKE-contains) operator to match the property-filter semantics
 * for tags, and ORs each selected tag so a row is kept when it carries any of
 * them.
 */
export const buildDashboardTagFilterGroup = (
  tagNames: string[],
  dataSourceIndex = 0
): FilterGroup | undefined => {
  if (tagNames.length === 0) {
    return undefined;
  }

  return {
    operation: 'or',
    filters: tagNames.map((name) => ({
      field: { fieldId: 'tags', dataSourceIndex },
      operator: ':',
      value: name,
    })),
  };
};
